<template>
  <div class="overflow-y-auto">
    <div
      class="min-w-[1300px] bg-[#F4F4F4] py-[6px] flex items-center focus:outline-none"
    >
      <collapse-header-checkbox
        v-model="checked"
        class-name="bg-[#F4F4F4]"
        @change="handleCheckboxChange"
      />
      <div class="grid grid-cols-6 grow text-[#333333]">
        <general-cell
          value="No. Order"
          class="select-all"
        />
        <general-cell value="Tanggal Order" />
        <general-cell value="Batas Pickup" />
        <general-cell value="Logisitik" />
        <general-cell value="Seller" />
        <general-cell value="Print Label" />
      </div>
      <div class="w-[36px]" />
    </div>
  </div>
</template>

<script>
import GeneralCell from './GeneralCell.vue'
import CollapseHeaderCheckbox from './CollapseHeaderCheckbox.vue'

export default {
  name: 'CollapseHeader',
  components: {
    GeneralCell,
    CollapseHeaderCheckbox,
  },
  data() {
    return {
      checked: false,
    }
  },
  computed: {
    checkboxDisabled() {
      const { status } = this.$route.query
      if (!status) {
        return false
      }
      return (status !== 'submitted' && status !== 'confirmed')
    },
  },
  methods: {
    handleCheckboxChange() {
      this.$emit('on-checked-change', this.checked)
    },
    setChecked(state) {
      this.checked = state
    },
  },
}
</script>
